import React, { Component, Fragment } from 'react';
import { Col, Row } from 'reactstrap';
import { inject, observer } from 'mobx-react/index';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';

import { modelOf } from '../../../prop-types';
import Purchase from '../../../models/Purchase';
import UIStore from '../../../store/UIStore';
import globalTranslations from '../../../i18n/globalTranslations';
import Icon from '../../common/Icon';

const labels = {
  name: <FormattedMessage {...globalTranslations.purchaseUserHeader} />,
  order_count: (
    <FormattedMessage {...globalTranslations.purchaseOrderCountHeader} />
  ),
  total_with_tax: (
    <FormattedMessage {...globalTranslations.purchaseWithVatHeader} />
  ),
  total_without_tax: (
    <FormattedMessage {...globalTranslations.purchaseWithoutVatHeader} />
  )
};

@observer
export class PurchaseTabTitle extends Component {
  renderMaybeHeader = (label, value) => {
    const { uiStore } = this.props;

    if (uiStore.isMobile) {
      return (
        <Fragment>
          <div className="PurchaseTabTitle__header">
            {label}
            {': '}
          </div>
          <div dangerouslySetInnerHTML={{ __html: value }} />
        </Fragment>
      );
    }
    return <div dangerouslySetInnerHTML={{ __html: value }} />;
  };

  render() {
    const { purchase } = this.props;
    return (
      <div className="PurchaseTabTitle">
        <Row className="PurchaseTabTitle__row">
          <Col md="4">
            <div>
              <Icon className="PurchaseTabTitle__toggle-icon" name="angle-up" />
            </div>
            <div className="PurchaseTabTitle__user">
              {this.renderMaybeHeader(labels.name, purchase.name)}
            </div>
          </Col>
          <Col md="2">
            <div className="PurchaseTabTitle__orderCount">
              {this.renderMaybeHeader(labels.order_count, purchase.order_count)}
            </div>
          </Col>
          <Col md="3">
            <div className="PurchaseTabTitle__purchasesWithVat">
              {this.renderMaybeHeader(
                labels.total_with_tax,
                purchase.total_with_tax
              )}
            </div>
          </Col>
          <Col md="3">
            <div className="PurchaseTabTitle__purchasesWithoutVat">
              {this.renderMaybeHeader(
                labels.total_without_tax,
                purchase.total_without_tax
              )}
            </div>
          </Col>
        </Row>
      </div>
    );
  }
}

PurchaseTabTitle.propTypes = {
  uiStore: modelOf(UIStore).isRequired,
  purchase: modelOf(Purchase).isRequired,
  searchParams: PropTypes.object.isRequired
};

export default inject('uiStore')(PurchaseTabTitle);



// WEBPACK FOOTER //
// ./src/components/purchase/PurchaseTabTitle/index.jsx